// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header[data-v-5e00b5fc]{height:30px;background:#007aff;line-height:30px;color:#fff;text-align:center;font-size:16px}", ""]);
// Exports
module.exports = exports;
